import Skeleton from "react-loading-skeleton";


export default function ButtonLoader() {
    return (
        <div className="w-[60%] flex items-center gap-3">
            <div className="w-full">
                <Skeleton className="h-[30px] rounded-full" />
            </div>
            <div className="w-full">
                <Skeleton className="h-[30px] rounded-full" />
            </div>
            <div className="w-full">
                <Skeleton className="h-[30px] rounded-full" />
            </div>
        </div>
    )
};